class SelectCrewController {
  /* @ngInject */
  constructor (Crews, crews, $mdDialog) {
    this.$mdDialog = $mdDialog
    this.crews = crews
    this.Crews = Crews
  }

  select (crew) {
    this.Crews.selectCrew(crew)
    this.$mdDialog.hide()
  }

  manage () {
    this.$mdDialog.cancel('manage')
  }
}

export default SelectCrewController
